export default __webpack_public_path__ + "static/media/6.92410e36.jpg";